import React, { useEffect, useMemo, useState } from 'react';
import Table from '@components/table';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import Button from '@components/common/button';
import Input from '@components/common/input';
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { TDocument } from '@xeppt/xeppt-sdk/types';
import { useDebounceValue } from 'usehooks-ts';
import Status from '@components/common/status';
import Dropdown from '@components/common/dropdown';
import { useAgreements } from '@hooks/api/useAgreement';

const AgreementsLayout = () => {
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [requestSearch, setRequestSearch] = useDebounceValue('', 500);
    const { agreements, handleChangeAgreementFilter, handleSetAsPrimary } = useAgreements({
        isInitialAgreements: true
    });

    const columns = [
        {
            label: 'Version',
            key: 'version',
            width: 150,
            render: (_: string, data: TDocument) => (
                <div className={styles.row}>
                    {data.version} {data.is_primary && <Status variant="success">Primary</Status>}
                </div>
            )
        },
        {
            label: 'Date created',
            key: 'created_at',
            width: 200,
            render: (value: string) => moment(value).format('MM.DD.YYYY HH:mm:ss')
        },
        {
            label: 'Summary',
            key: 'summary'
        },
        {
            label: 'Actions',
            key: 'id',
            width: 150,
            render: (value: string) => (
                <Dropdown
                    items={[
                        {
                            label: 'View',
                            onClick: () => navigate(`${routes.agreements}/${value}`)
                        },
                        {
                            label: 'Use as template',
                            onClick: () => navigate(`${routes.agreements}/${value}?template=true`)
                        },
                        {
                            label: 'Set as primary',
                            onClick: () => handleSetAsPrimary(value)
                        }
                    ]}
                />
            )
        }
    ];

    useEffect(() => {
        setRequestSearch(search);
    }, [search]);

    useEffect(() => {
        if (requestSearch.length >= 3) {
            handleChangeAgreementFilter({ version: search });
        } else {
            handleChangeAgreementFilter({ version: undefined });
        }
    }, [requestSearch]);

    const count = useMemo(() => {
        if (agreements?.pages_total === 1) return agreements?.data?.length || 0;
        return (agreements?.page_size || 0) * (agreements?.pages_total || 0);
    }, [agreements]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.text_wrapper}>
                    <Typography variant="h4">Cardholder agreement</Typography>
                    <Typography>{count} records found</Typography>
                </div>
                <div className={styles.actions}>
                    {/*<RangeDatePicker*/}
                    {/*    values={[]}*/}
                    {/*    maxDate={getDisableFeature()}*/}
                    {/*    onChange={(val) => {}}*/}
                    {/*/>*/}
                    <Input
                        className={styles.search}
                        leftIcon="search"
                        value={search}
                        onChange={(val) => setSearch(val)}
                        placeholder="Search by version or summary..."
                    />
                    <Button
                        variant="primary"
                        size="medium"
                        onClick={() =>
                            navigate(
                                `${routes.agreements}/${agreements?.data?.find((item) => item.is_primary)?.id}?template=true`
                            )
                        }>
                        Create new version
                    </Button>
                </div>
            </div>
            <Table
                //@ts-ignore
                columns={columns}
                rows={agreements?.data || []}
                // sort={{ key: 'created_at', value: filter.order }}
                // onSortChange={() => {
                //     handleChangeAdminsFilter({
                //         order: filter.order === 'DESC' ? 'ASC' : 'DESC'
                //     });
                // }}
                //@ts-ignore
                // filter={filter as TFilter}
                isActions
                // onFilterChange={(val) => handleChangeAdminsFilter(val)}
                emptyDescription="Agreements list is empty"
            />
        </div>
    );
};

export default AgreementsLayout;
